/**
 * Correspondance entre les 5 jalons cibles de la Project Identity Sheet (§02)
 * et les `templateId` du gabarit ScaleUp (`programTemplates.ts`).
 *
 * `ER` et `PR` du PAD SONT Engineering Run et Pilot Run — 4 correspondances sur
 * 5 sont certaines. `designFreeze` reste NON MAPPÉ : ses deux candidats
 * (`architecture-sor`, `dfm`) attendent l'arbitrage de Mélanie, et sa date est
 * conservée dans la référence sans amorcer quoi que ce soit.
 *
 * ATTENTION : un `templateId` n'est PAS un id de document. `seedProgramMilestones`
 * crée les jalons avec des ids auto-générés en y conservant `templateId` comme
 * champ ; seule la reprise du PAD (`tools/pad/import.ts`) écrit sous
 * `milestones/{templateId}`. Tout appelant doit donc résoudre le vrai id.
 *
 * ponytail: table valable pour ScaleUp seulement. LaunchPad/UnLock sont en
 * J1–J4, sans vocabulaire commun avec la fiche — ils stockent leurs dates et
 * n'amorcent rien. Seconde table le jour où ces programmes en auront besoin.
 */
import type { Timestamp } from 'firebase/firestore';
import type { ApMilestoneKey, AvantProjet } from '@altyor-kronos/shared-types';

export const AP_MILESTONE_MAP: Partial<Record<ApMilestoneKey, string>> = {
  kickOff: 'kick-off',
  engineeringRun: 'er-mr',
  pilotRun: 'pr',
  sop: 'sop',
};

export interface ApMilestoneSeed {
  templateId: string;
  date: Timestamp;
}

/**
 * Ce que la création doit écrire comme `targetDate`, dérivé des dates de
 * référence. Pure : ne lit rien, n'écrit rien, ne mute pas son entrée.
 */
export function apMilestoneSeeds(ap: AvantProjet | undefined): ApMilestoneSeed[] {
  const dates = ap?.baselineDates;
  if (!dates) return [];
  return Object.entries(AP_MILESTONE_MAP).flatMap(([apKey, templateId]) => {
    const date = dates[apKey as ApMilestoneKey];
    return date ? [{ templateId, date }] : [];
  });
}
